import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { DataThirdCompanyEntity } from '../../../../data/repositories/configuration/entities/company/third-company.entity';
import { ThirdCompanyResponseModel } from '../../../models/configuration/company/third-company.model';

export class UpdateThirdCompanyUseCase implements UseCase<DataThirdCompanyEntity, ThirdCompanyResponseModel> {
    constructor(private ThirdCompanyRepository: ConfigurationRepository) { }
    execute(
        params: DataThirdCompanyEntity,
    ): Observable<ThirdCompanyResponseModel> {
        return this.ThirdCompanyRepository.updateThirdCompany(params);
    }
}
